import { PropsWithChildren } from 'react';
import { Stack } from '@mui/material';
import { Widget } from '@/shared/Constants';
export const TrustBoxPriceDetailsMobileCallToActionBar = ({
  children
}: PropsWithChildren) => <Stack sx={{
  display: 'grid',
  columnGap: 5,
  gridTemplateColumns: 'auto 1fr',
  gridTemplateRows: 'auto auto',
  bgcolor: 'common.backgroundColor',
  position: 'fixed',
  bottom: Widget.VERTICAL_STYLE_NAVBAR_HEIGHT,
  left: 0,
  right: 0,
  zIndex: 'appBar',
  py: 1,
  px: 3,
  boxShadow: 2
}} data-sentry-element="Stack" data-sentry-component="TrustBoxPriceDetailsMobileCallToActionBar" data-sentry-source-file="TrustBoxPriceDetailsMobileCallToActionBar.tsx">
    {children}
  </Stack>;